module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/core-js/library/modules/_fails.js
// module id = ../../../../core-js/library/modules/_fails.js
// module chunks = 4